if (!customElements.get('annais-menu-promise')) {
  customElements.define('annais-menu-promise', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;
      this.sync = () => {
        const open = this.classList.contains('submenu-opened');
        this.button.setAttribute('aria-expanded', String(open));
        this.nextElementSibling?.querySelectorAll('a').forEach(link => link.tabIndex = open ? 0 : -1);
      };
      this.toggle = () => { this.classList.toggle('submenu-opened'); this.sync(); };
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this, { attributes: true, attributeFilter: ['class'] });
      this.button.addEventListener('click', this.toggle);
    }
    disconnectedCallback() { this.observer?.disconnect(); this.button?.removeEventListener('click', this.toggle); }
  });
}
